<div class="p-4">
  <!-- Legal Assistance Reasons (for automotive legal assistance) -->
  <div *ngIf="!isFuneralService">
    <h2 class="headline-06 mb-2 md:mt-3 text-[#0E365A]">Motivos de Asistencia Legal</h2>
    <p class="text-[#3D4E5F] paragraph-default mb-4">Selecciona el motivo de tu consulta legal</p>

    <div class="space-y-3 mb-6">
      <div
        *ngFor="let motivo of motivosLegales"
        (click)="seleccionarMotivo(motivo.dsMotivo)"
        class="bg-[#D2E4FF29] border rounded-[20px] p-4 flex justify-between items-center cursor-pointer"
        [class.border-[#0E365A]]="motivoSeleccionado === motivo.dsMotivo"
        [class.border-[#B0C4DE]]="motivoSeleccionado !== motivo.dsMotivo">
        <div class="text-[#0E365A]">
          <p class="paragraph-medium font-semibold">{{ motivo.dsMotivo }}</p>
        </div>
        <div
          class="w-5 h-5 rounded-full border-2 flex items-center justify-center"
          [class.border-[#0E365A]]="motivoSeleccionado === motivo.dsMotivo"
          [class.bg-[#0E365A]]="motivoSeleccionado === motivo.dsMotivo"
          [class.border-gray-300]="motivoSeleccionado !== motivo.dsMotivo">
          <div
            *ngIf="motivoSeleccionado === motivo.dsMotivo"
            class="w-2 h-2 bg-white rounded-full">
          </div>
        </div>
      </div>
    </div>

    <!-- Selección de beneficiario -->
    <div class="mb-6">
      <!--h2 class="headline-06 text-[#0E365A] font-bold mb-3">Selecciona el beneficiario</h2-->
      <h2 class="headline-06 mb-2 md:mt-3 text-[#0E365A]">Nombre</h2>
      <!-- Titular -->
      <div class="mb-3">
        <mat-radio-group [(ngModel)]="selectedPatient" class="flex flex-col gap-2">
          <div class="flex items-center bg-[#D2E4FF29] border border-[#B0C4DE] rounded-[20px] px-4 py-2 cursor-pointer min-h-[60px]">
            <mat-icon class="flex-shrink-0">person</mat-icon>
            <div class="ml-2 flex-1 min-w-0">
              <p class="font-semibold truncate">{{ nameOwner }}</p>
              <p class="text-sm text-gray-500">Titular</p>
            </div>
            <mat-radio-button class="ml-2 flex-shrink-0" value="titular"></mat-radio-button>
          </div>
      <!-- DEPENDIENTES OCULTOS TEMPORALMENTE
        <div *ngIf="dependent.length > 0" class="flex items-center bg-[#D2E4FF29] border border-[#B0C4DE] rounded-[20px] px-4 py-2 cursor-pointer min-h-[60px]">
          <mat-icon class="flex-shrink-0">person</mat-icon>
          <div class="ml-2 flex-1 min-w-0">
            <p class="font-semibold truncate">{{ dependent[0].name }}</p>
            <p class="text-sm text-gray-500 truncate">{{ dependent[0].catalog.description }}</p>
          </div>
          <mat-radio-button class="ml-2 flex-shrink-0" [value]="dependent[0].name"></mat-radio-button>
        </div>

        <ng-container *ngIf="showAllDependents">
          <div *ngFor="let dep of dependent.slice(1)" class="flex items-center bg-[#D2E4FF29] border border-[#B0C4DE] rounded-[20px] px-4 py-2 cursor-pointer min-h-[60px]">
            <mat-icon class="flex-shrink-0">person</mat-icon>
            <div class="ml-2 flex-1 min-w-0">
              <p class="font-semibold truncate">{{ dep.name }}</p>
              <p class="text-sm text-gray-500 truncate">{{ dep.catalog.description }}</p>
            </div>
            <mat-radio-button class="ml-2 flex-shrink-0" [value]="dep.name"></mat-radio-button>
          </div>
        </ng-container>
      FIN DEPENDIENTES OCULTOS TEMPORALMENTE -->
        </mat-radio-group>
      </div>

      <!-- DEPENDIENTES OCULTOS TEMPORALMENTE
      <button *ngIf="dependent.length > 1" class="w-full mt-2 border border-[#0E365A] rounded-full p-2 flex justify-between items-center" (click)="toggleDependents()">
        <p class="button-small text-[#0E365A]">{{ showAllDependents ? 'Ocultar dependientes' : 'Ver más dependientes' }}</p>
        <mat-icon>{{ showAllDependents ? 'remove' : 'add' }}</mat-icon>
      </button>
      <div
        class="w-full mt-2 border border-[#0E365A] rounded-full p-2 flex justify-between items-center"
        (click)="addNewDependent()">
        <p class="button-small text-[#0E365A]">Agregar nuevo dependiente</p>
        <mat-icon>add</mat-icon>
      </div>
      FIN DEPENDIENTES OCULTOS TEMPORALMENTE -->
    </div>

    <button
      (click)="confirmarAsistencia()"
      [disabled]="!motivoSeleccionado || !selectedPatient"
      class="w-full py-2 rounded-full transition"
      [class.bg-[#0E365A]]="motivoSeleccionado"
      [class.text-white]="motivoSeleccionado"
      [class.border]="!motivoSeleccionado"
      [class.border-[#0E365A]]="!motivoSeleccionado"
      [class.text-[#0E365A]]="!motivoSeleccionado"
      [class.opacity-50]="!motivoSeleccionado"
      [class.cursor-not-allowed]="!motivoSeleccionado">
      Confirmar Asistencia
    </button>
  </div>

  <!-- Dependent Catalog (for funeral services) -->
  <div *ngIf="isFuneralService" class="max-w-2xl mx-auto">
    <!--h1 class="headline-05 text-[#003746] font-bold">Selecciona el beneficiario</h1-->

    <!-- Nombre del paciente -->
    <div class="mb-2">
      <h2 class="headline-05 text-[#003746] font-bold my-3">Titular</h2>
      <mat-radio-group [(ngModel)]="selectedPatient">
        <div class="flex items-center border border-[#DFF2F5] bg-[#D2E4FF29] rounded-[16px] px-4 py-2" [class.border-2]="isSelected('titular')">
          <div class="flex items-center gap-2">
            <svg width="24" height="24" viewBox="0 0 16 21" fill="#003746" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.7543 12.4992C14.9963 12.4992 16.0032 13.5061 16.0032 14.7481V15.3235C16.0032 16.2178 15.6836 17.0826 15.1021 17.762C13.5327 19.5955 11.1455 20.5004 8.00012 20.5004C4.85426 20.5004 2.46825 19.5952 0.901942 17.7609C0.322181 17.082 0.00366211 16.2185 0.00366211 15.3258V14.7481C0.00366211 13.5061 1.01052 12.4992 2.25254 12.4992H13.7543ZM13.7543 13.9992H2.25254C1.83895 13.9992 1.50366 14.3345 1.50366 14.7481V15.3258C1.50366 15.8614 1.69477 16.3795 2.04263 16.7869C3.29594 18.2546 5.26182 19.0004 8.00012 19.0004C10.7384 19.0004 12.706 18.2545 13.9625 16.7866C14.3114 16.379 14.5032 15.8601 14.5032 15.3235V14.7481C14.5032 14.3345 14.1679 13.9992 13.7543 13.9992ZM8.00012 0.503906C10.7615 0.503906 13.0001 2.74248 13.0001 5.50391C13.0001 8.26533 10.7615 10.5039 8.00012 10.5039C5.2387 10.5039 3.00012 8.26533 3.00012 5.50391C3.00012 2.74248 5.2387 0.503906 8.00012 0.503906ZM8.00012 2.00391C6.06712 2.00391 4.50012 3.57091 4.50012 5.50391C4.50012 7.4369 6.06712 9.00391 8.00012 9.00391C9.93312 9.00391 11.5001 7.4369 11.5001 5.50391C11.5001 3.57091 9.93312 2.00391 8.00012 2.00391Z"/>
              </svg>
            <div>
              <p class="font-semibold">{{ nameOwner }}</p>
              <p class="paragraph-small text-[#97795B]">Titular</p>
            </div>
          </div>
          <mat-radio-button class="ml-auto" value="titular"></mat-radio-button>
        </div>
      </mat-radio-group>
    </div>

    <!-- DEPENDIENTES OCULTOS TEMPORALMENTE (funeral)
    <div class="mb-4">
      <h2 class="headline-05 text-[#003746] font-bold my-3">Dependientes</h2>
      <mat-radio-group [(ngModel)]="selectedPatient" class="space-y-2 block">
        <div *ngFor="let dep of dependent" class="flex items-center border border-[#DFF2F5] bg-[#D2E4FF29] rounded-[16px] px-4 py-2" [class.border-2]="isSelected(dep.name)">
          <div class="flex items-center gap-2">
            <svg width="24" height="24" viewBox="0 0 16 21" fill="#003746" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.7543 12.4992C14.9963 12.4992 16.0032 13.5061 16.0032 14.7481V15.3235C16.0032 16.2178 15.6836 17.0826 15.1021 17.762C13.5327 19.5955 11.1455 20.5004 8.00012 20.5004C4.85426 20.5004 2.46825 19.5952 0.901942 17.7609C0.322181 17.082 0.00366211 16.2185 0.00366211 15.3258V14.7481C0.00366211 13.5061 1.01052 12.4992 2.25254 12.4992H13.7543ZM13.7543 13.9992H2.25254C1.83895 13.9992 1.50366 14.3345 1.50366 14.7481V15.3258C1.50366 15.8614 1.69477 16.3795 2.04263 16.7869C3.29594 18.2546 5.26182 19.0004 8.00012 19.0004C10.7384 19.0004 12.706 18.2545 13.9625 16.7866C14.3114 16.379 14.5032 15.8601 14.5032 15.3235V14.7481C14.5032 14.3345 14.1679 13.9992 13.7543 13.9992ZM8.00012 0.503906C10.7615 0.503906 13.0001 2.74248 13.0001 5.50391C13.0001 8.26533 10.7615 10.5039 8.00012 10.5039C5.2387 10.5039 3.00012 8.26533 3.00012 5.50391C3.00012 2.74248 5.2387 0.503906 8.00012 0.503906ZM8.00012 2.00391C6.06712 2.00391 4.50012 3.57091 4.50012 5.50391C4.50012 7.4369 6.06712 9.00391 8.00012 9.00391C9.93312 9.00391 11.5001 7.4369 11.5001 5.50391C11.5001 3.57091 9.93312 2.00391 8.00012 2.00391Z"/>
              </svg>
            <div>
              <p class="font-semibold">{{ dep.name }}</p>
              <p class="paragraph-small text-[#97795B]">{{ dep.catalog.description }}</p>
            </div>
          </div>
          <mat-radio-button class="ml-auto" [value]="dep.name"></mat-radio-button>
        </div>
      </mat-radio-group>

      <div
        class="w-full mt-3 border border-[#0E365A] text-[#0E365A] rounded-[16px] cursor-pointer py-3 px-4 flex items-center justify-between hover:bg-gray-50"
        (click)="addNewDependent()">
        <span>Agregar nuevo dependiente</span>
        <mat-icon>add</mat-icon>
      </div>
    </div>
    FIN DEPENDIENTES OCULTOS TEMPORALMENTE -->

    <!-- Botón solicitar -->
    <button
      class="bg-[#052631] text-white w-full py-3 rounded-full"
      [disabled]="!selectedPatient"
      [class.opacity-50]="!selectedPatient"
      [class.cursor-not-allowed]="!selectedPatient"
      (click)="confirmarAsistencia()">
      Solicitar
    </button>
  </div>
</div>
